export class ExtraSalesModal {
  constructor(element) {
    this._refs = {
      el: element,
      select: element.querySelector('[data-select] select'),
    };

    this._init();
  }

  _watchDropdownChanges() {
    this._refs.select.addEventListener('change', this._toggleAddEarmoldButton.bind(this));
  }

  _toggleAddEarmoldButton() {
    const disabledButton = () => {
      addEarmoldButton.disabled = true;
      addEarmoldButton.setAttribute('disabled', '');
      addEarmoldButton.classList.add('is-disabled');
    };

    const enabledButton = () => {
      addEarmoldButton.disabled = false;
      addEarmoldButton.removeAttribute('disabled');
      addEarmoldButton.classList.remove('is-disabled');
    };

    const addEarmoldButton = this._refs.el.querySelector(
      'input[type="submit"][id*="AddEarmoldTextEditableButton"]',
    );
    // Toggle button logic
    this.validateButton ? enabledButton() : disabledButton();
  }

  get validateButton() {
    const dropdownValue = this._refs.select.value;
    return dropdownValue && dropdownValue.toLowerCase() !== 'none';
  }

  _init() {
    this._watchDropdownChanges();
    this._toggleAddEarmoldButton();
  }
}
